import { Component, OnInit, OnDestroy, NgZone, EventEmitter, ViewChild, Input } from '@angular/core';

import { ModalDirective } from 'ngx-bootstrap/modal';

import { Subscription } from 'rxjs';

import {
    PresetService,
    DataArray,
    Preset,
    ToastrService
} from './../../../../shared/index';

@Component({
    selector: 'preset-list',
    templateUrl: './preset-list.html',
    standalone: false
})

export class PresetListComponent implements OnInit, OnDestroy {
    @ViewChild('AddPreset') modal: ModalDirective;
    @Input() color = 'panel-success';
    public bounding: any;
    public presets: DataArray<Preset> = new DataArray<Preset>(1);
    public preset: Preset = new Preset();
    public processing = true;
    public NewPreset = '';
    private subscriptions: Subscription[] = [];

    constructor(
        private _ngZone: NgZone,
        private _presetService: PresetService,
        private _toastrService: ToastrService,
    ) {
        this.subscriptions.push(this._presetService.filteredPresetsChange.subscribe((info: any) => {
            this._ngZone.run(() => {
                this.presets = new DataArray<Preset>(1);
                for (const preset of info) {
                    this.presets.update(preset, true);
                }
                 this.processing = false;
            });
        }));

        this.subscriptions.push(this._presetService.presetChange.subscribe((info: any) => {
            this._ngZone.run(() => {
                this.presets = new DataArray<Preset>(1);
                for (const preset of info) {

                    this.presets.update(preset, true);
                }
                this.processing = false;
            });
        }));

        this.subscriptions.push(this._presetService.beginFilter.subscribe((info: boolean) => {
            this._ngZone.run(() => {
                this.presets.init();
            });
        }));
    }

    public showModal( ): void {
        this.modal.show();
    }

    public closeModal() {
        this.modal.hide();
        this.NewPreset = '';
    }

    public createPreset() {
        this._presetService.create(this.NewPreset);
        this.closeModal()
    }

    public createPresetAndAddAnother() {
        this._presetService.create(this.NewPreset);
        this.NewPreset = '';
    }

    ngOnInit(): void {
        this.presets.init();
        this.processing = true;
        this._presetService.getPresets();
    }

    ngOnDestroy(): void {
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
}
